/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The Temperature model module.
* @module model/Temperature
* @version 2020-12-7
*/
export default class Temperature {
    /**
    * Constructs a new <code>Temperature</code>.
    * @alias module:model/Temperature
    * @class
    * @param max {Number} 
    * @param min {Number} 
    */

    constructor(max, min) {
        
        
        this['max'] = max;
        this['min'] = min;
        
    }

    /**
    * Constructs a <code>Temperature</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Temperature} obj Optional instance to populate.
    * @return {module:model/Temperature} The populated <code>Temperature</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Temperature();
                        
            
            if (data.hasOwnProperty('max')) {
                obj['max'] = ApiClient.convertToType(data['max'], 'Number');
            }
            if (data.hasOwnProperty('min')) {
                obj['min'] = ApiClient.convertToType(data['min'], 'Number');
            }
        }
        return obj;
    }

    /**
    * @member {Number} max
    */
    'max' = undefined;
    /**
    * @member {Number} min
    */
    'min' = undefined;




}
